var $f44b7cf39ac8f315$exports = {};
$f44b7cf39ac8f315$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Izbirnik barv`,
    "colorSwatch": `barvna paleta`,
    "transparent": `prozorno`,
    "twoDimensionalSlider": `2D drsnik`
};


export {$f44b7cf39ac8f315$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
